/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/* eslint-disable arrow-parens */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const blockIconURI = require('./aixiong-logo.svg');
const menuIconURI = blockIconURI;
const to16 = (str) => {
    // console.log(str)
    let result10 = 0
    for (let index = 0; index < str.length; index++) {
        // str
        if (str.charAt(index) == 1) {
            result10 += Math.pow(10, index)
        }
    }
    let result2 = parseInt(result10, 2)
    let result16 = result2.toString(16)
    if (result16.length == 1) {
        result16 = '0' + result16
    }
    let result = '0x' + result16
    // console.log(result)
    return result
}

const to2 = (str) => {
    const strArray = []
    strArray[0] = '0x' + str.substring(14, 16)
    strArray[1] = '0x' + str.substring(12, 14)
    strArray[2] = '0x' + str.substring(10, 12)
    strArray[3] = '0x' + str.substring(8, 10)
    strArray[4] = '0x' + str.substring(6, 8)
    strArray[5] = '0x' + str.substring(4, 6)
    strArray[6] = '0x' + str.substring(2, 4)
    strArray[7] = '0x' + str.substring(0, 2)
    let result = ''
    for (let index = 0; index < strArray.length; index++) {
        let element = strArray[index];
        let result10 = parseInt(element)
        let result2 = (result10).toString(2)
        if (result2.length < 8) {
            let zero = '00000000'
            result2 = zero.substring(0, (8 - result2.length)) + result2
        }
        result += result2
    }
    return result
}
to2('0000010204885020')
const analogTrans = {
    'A0': 0,
    'A1': 1
}
const analogTransMap = {
    0: 'A0',
    1: 'A1'
}

const gesMap = {
    1: '上',
    2: '下',
    3: '左',
    4: '右',
    5: '远',
    6: '近'
}
const colorMap = {
    0: '无',
    1: '红',
    2: '绿',
    3: '蓝',
    4: '黄',
    5: '白',
    6: '',
    7: '',
    8: '',
}
const numRGBMap = {
    1: 'sensorColorRedValue',
    2: 'sensorColorGreenValue',
    3: 'sensorColorBlueValue'
}

const valueDelayPromise = (value, max = 20) => {
    return new Promise(resolve => {
        let count = 0
        let _interval = setInterval(() => {
            count++
            if (count >= max) {
                clearInterval(_interval)
                _interval = null
                resolve(value)
            }
        }, 100)
    });
    // valuePromise.then(value => value);
}
// const valueDelay = valueDelayPromise.bind(aixiongBlocks)

class aixiongBlocks {
    constructor (runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        const _this = this
        this.runtime = runtime;
        // console.log('this.runtime --> ', runtime)
        
        if (this.runtime.ioDevices) {
            this.ioDevices = this.runtime.ioDevices
            this.Aixiong = this.ioDevices.Aixiong
            this.runMode = this.Aixiong.runMode
            // this.socket = this.Aixiong.socket
            this.adaptor = this.Aixiong.adaptor
            this.guiTovm = this.Aixiong.guiTovm
            this.Aixiong.fnCallback = [] // 确保硬件保留一个监听
            this.Aixiong.fnCallback.push(() => {
                if (_this.guiTovm.state != _this.Aixiong.guiTovm.state){
                    // code
                    _this.guiTovm = _this.Aixiong.guiTovm
                    // if (_this.guiTovm.method == 'runCodeFn') {
                    //     _this.runCodeFn(_this.guiTovm.data)
                    // }
                    // if (_this.guiTovm.method == 'brushCodeFn') {
                    //     _this.brushCodeFn(_this.guiTovm.data)
                    // }
                    _this.socket && _this.socket.emit('code_from_arduino', {payload: _this.guiTovm.data});
                }
                if (_this.runMode != _this.Aixiong.runMode) {
                    _this.runMode = _this.Aixiong.runMode
                    // if (_this.runMode == 1) {
                        
                    // } else {
                        
                    // }
                }
            })
            this.running = false
            console.log('this.ioDevices --> ', this.ioDevices)
        }
        this.ledPin = ''
        this.motorPin = ''
        this.matrixPin = ''
        this.sensorPhotosensitivePin = ''
        this.sensorSoundPin = ''
        this.sensorAvoidancePin = ''
        this.ledPinMode = ''
        this.motorPinMode = ''
        this.matrixPinMode = ''
        this.sensorPhotosensitivePinMode = ''
        this.sensorSoundPinMode = ''
        this.sensorAvoidancePinMode = ''
        this.ledPinValue = ''
        this.motorPinValue = ''
        this.matrixPinValue = ''
        this.sensorPhotosensitivePinValue = ''
        this.sensorSoundPinValue = ''
        this.sensorAvoidancePinValue = ''

        this.sensorColorValue = ''
        this.sensorColorRedValue = ''
        this.sensorColorGreenValue = ''
        this.sensorColorBlueValue = ''
        this.sensorGestureValue = ''

        this.timing = () => {
            // console.log('in timing')
            setTimeout(() => {
                // console.log('in timeout')
                if (this.Aixiong) {
                    // console.log(this.Aixiong)
                    this.runMode = this.Aixiong.runMode
                    
                    this.adaptor = this.Aixiong.adaptor
                    // console.log('this.runMode --> ', this.runMode)
                    // console.log('this.Aixiong.socket --> ', this.Aixiong.socket)
                    // console.log('this.socket --> ', this.socket)

                    this.running = false
                    if (this.Aixiong.socket && !this.socket) {
                        console.log('trans_from_aibear add');
                        this.socket = this.Aixiong.socket
                        this.socket.removeEventListener('trans_from_aibear')
                        setTimeout(() => {
                            console.log('trans_from_aibear listen');
                            this.socket.on('trans_from_aibear', (data) => {
                                this.running = false
                                console.log('data:\n', data);
                                if (data.data.err) {
                                    console.log('err: ', data.data.err);
                                } else {
                                    console.log('msg: ', data.data.msg);
                                    if (data.data.data) {
                                        console.log('data: ', data.data.data);
                                        // console.log('method: ', data.data.method);
                                        // console.log(this.sensorPhotosensitivePin)
                                        // console.log(this.sensorSoundPin)
                                        // console.log(this.sensorAvoidancePin)
                                        console.log((analogTrans[this.sensorPhotosensitivePin] || this.sensorPhotosensitivePin))
                                        if (data.data.method == 'analogRead') {
                                            if (analogTrans[this.sensorPhotosensitivePin] == data.data.data.pin) {
                                                this.sensorPhotosensitivePinValue = data.data.data.value
                                                console.log('--> ', this.sensorPhotosensitivePinValue)
                                            }
                                            if (analogTrans[this.sensorSoundPin] == data.data.data.pin) {
                                                this.sensorSoundPinValue = data.data.data.value
                                                console.log('--> ', this.sensorSoundPinValue)
                                            }
                                            if (analogTrans[this.sensorAvoidancePin] == data.data.data.pin) {
                                                this.sensorAvoidancePinValue = data.data.data.value
                                                console.log('--> ', this.sensorAvoidancePinValue)
                                            }
                                        }
                                        if (data.data.method == 'digitalRead') {
                                            if (this.sensorPhotosensitivePin == data.data.data.pin) {
                                                this.sensorPhotosensitivePinValue = data.data.data.value
                                            }
                                            if (this.sensorSoundPin == data.data.data.pin) {
                                                this.sensorSoundPinValue = data.data.data.value
                                            }
                                            if (this.sensorAvoidancePin == data.data.data.pin) {
                                                this.sensorAvoidancePinValue = data.data.data.value
                                            }
                                        }
                                        if (data.data.method == 'showGesture') {
                                            if (this.sensorGestureValue == '' || this.sensorGestureValue == 0) {
                                                
                                            }
                                            this.sensorGestureValue = data.data.data.value + ''
                                        }
                                        if (data.data.method == 'showSensorColor') {
                                            this.sensorColorRedValue = data.data.data.r + ''
                                            this.sensorColorGreenValue = data.data.data.g + ''
                                            this.sensorColorBlueValue = data.data.data.b + ''
                                            this.sensorColorValue = data.data.data.value + ''
                                        }
                                    }
                                    
                                }
                            });
                        }, 300)
                        
                        // board.matrix_set = this.firmata_matrix_set // pin1, pin2
                        // board.matrix_rotate = this.firmata_matrix_rotate // rotate
                        // board.matrix_speed = this.firmata_matrix_speed // speed
                        // board.matrix_show = this.firmata_matrix_show // data
                        // board.digitalWrite(pin, board.HIGH) 1
                        // board.digitalWrite(pin, board.LOW) 0
                        // digitalRead(pin, (value) => {
                        //     scratch3 && scratch3.emit('trans_from_aibear', { 
                        //         data: {
                        //             method: 'digitalRead',
                        //             data: { pin, value },
                        //             err: '开发板尚未准备好'
                        //         }
                        //     })
                        // })

                        // board.analogWrite(pin, num)
                        // board.pinMode(pin, board.MODES.PWM)
                    } else if (!this.Aixiong.socket){
                        this.socket = null
                    }
                }
                this.timing()
            }, 1000)
        }
        this.timing()
    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY () {
        return 'Scratch.aixiong';
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo () {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: 'aixiong',
            name: '爱熊套件',
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            color1: '#29beaf',
            color2: '#25ab9e',
            color3: '#21988c',
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                {
                    // Required: the machine-readable name of this operation.
                    // This will appear in project JSON.
                    opcode: 'baseSetup',
                    // Required: the kind of block we're defining, from a predefined list.
                    // Fully supported block types:
                    //   BlockType.BOOLEAN - same as REPORTER but returns a Boolean value
                    //   BlockType.COMMAND - a normal command block, like "move {} steps"
                    //   BlockType.HAT - starts a stack if its value changes from falsy to truthy ("edge triggered")
                    //   BlockType.REPORTER - returns a value, like "direction"
                    // Block types in development or for internal use only:
                    //   BlockType.BUTTON - place a button in the block palette
                    //   BlockType.CONDITIONAL - control flow, like "if {}" or "if {} else {}"
                    //     A CONDITIONAL block may return the one-based index of a branch to
                    //     run, or it may return zero/falsy to run no branch.
                    //   BlockType.EVENT - starts a stack in response to an event (full spec TBD)
                    //   BlockType.LOOP - control flow, like "repeat {} {}" or "forever {}"
                    //     A LOOP block is like a CONDITIONAL block with two differences:
                    //     - the block is assumed to have exactly one child branch, and
                    //     - each time a child branch finishes, the loop block is called again.
                    blockType: BlockType.CONDITIONAL,
                    // Required for CONDITIONAL blocks, ignored for others: the number of
                    // child branches this block controls. An "if" or "repeat" block would
                    // specify a branch count of 1; an "if-else" block would specify a
                    // branch count of 2.
                    // TODO: should we support dynamic branch count for "switch"-likes?
                    branchCount: 2,
                    // Optional, default false: whether or not this block ends a stack.
                    // The "forever" and "stop all" blocks would specify true here.
                    isTerminal: true,
                    // Required: the human-readable text on this block, including argument
                    // placeholders. Argument placeholders should be in [MACRO_CASE] and
                    // must be [ENCLOSED_WITHIN_SQUARE_BRACKETS].
                    text: ['爱熊编程 Setup', 'Loop'],
                    // message2: "loop",
                    hatType: true
                    // isEdgeActivated: true,
                    // previousStatement: null,
                    // nextStatement: null,
                    // Optional: the function implementing this block.
                    // If absent, assume `func` is the same as `opcode`.
                    // func: 'noop'
                },
                {
                    opcode: 'setModuleToPin',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'aixiong.setModuleToPin',
                        default: '将 [modules] 端口设置为 [aixiongPin]',
                        description: 'setModuleToPin'
                    }),
                    arguments: {
                        modules: {
                            type: ArgumentType.STRING,
                            menu: 'modules',
                            defaultValue: 'ledPin'
                        },
                        aixiongPin: {
                            type: ArgumentType.STRING,
                            menu: 'aixiongPin',
                            defaultValue: '5'
                        }
                    }
                },
                {
                    opcode: 'changeLedDigit',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeLedDigit',
                        default: '将七彩变色灯设为 [ledDigit]',
                        description: 'changeLedDigit'
                    }),
                    arguments: {
                        // 方括号中定义的
                        ledDigit: {
                            type: ArgumentType.STRING,
                            menu: 'ledDigit',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'changeLedAnalog',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeLedAnalog',
                        default: '调节七彩变色灯亮度 [ledAnalog](0~255)',
                        description: 'changeLedAnalog'
                    }),
                    arguments: {
                        ledAnalog: {
                            type: ArgumentType.STRING,
                            defaultValue: '50'
                        }
                    }
                },

                // just for fun
                // {
                //     opcode: "say",
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: "aixiong.say",
                //         default: "say [TEXT]",
                //         description: "say something",
                //     }),
                //     arguments: {
                //         TEXT: {
                //             type: ArgumentType.STRING,
                //             defaultValue: formatMessage({
                //                 id: "aixiong.defaultTextToSay",
                //                 default: "hello world",
                //                 description: "default text to say.",
                //             }),
                //         },
                //     },
                // },
                // {
                //     opcode: "showDelay",
                //     blockType: BlockType.REPORTER,
                //     text: formatMessage({
                //         id: "aixiong.showDelay",
                //         default: "可调节延期块",
                //         description: "showDelay",
                //     }),
                // },
                {
                    opcode: 'changeMotorAnalog',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeMotorAnalog',
                        default: '调节电机转速 [motorAnalog](-255~255)',
                        description: 'changeMotorAnalog'
                    }),
                    arguments: {
                        motorAnalog: {
                            type: ArgumentType.STRING,
                            defaultValue: '50'
                        }
                    }
                },
                {
                    opcode: 'changeMatrixText',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeMatrixText',
                        default: '让点阵屏显示 [matrixText]（数字，字母）',
                        description: 'changeMatrixText'
                    }),
                    arguments: {
                        matrixText: {
                            type: ArgumentType.STRING,
                            defaultValue: 'AIBear'
                        }
                    }
                }, {
                    opcode: 'changeMatrixRotation',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeMatrixRotation',
                        default: '点阵屏显示旋转 [matrixRotation]',
                        description: 'changeMatrixRotation'
                    }),
                    arguments: {
                        matrixRotation: {
                            type: ArgumentType.STRING,
                            menu: 'matrixRotation',
                            defaultValue: '0'
                        }
                    }
                }, {
                    opcode: 'changeMatrixTextDuration',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'aixiong.changeMatrixTextDuration',
                        default: '点阵屏显示时间间隔 [matrixTextDuration] 秒',
                        description: 'changeMatrixTextDuration'
                    }),
                    arguments: {
                        matrixTextDuration: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                }, {
                    opcode: 'displayMatrix',
                    blockType: BlockType.COMMAND, // ArgumentType BOOLEAN, BOOLEAN, COMMAND, MATRIX8
                    text: formatMessage({
                        id: 'aixiong.displayMatrix',
                        default: '点阵屏自定义图形 [MATRIX8]',
                        description: 'displayMatrix'
                    }),
                    arguments: {
                        MATRIX8: {
                            type: ArgumentType.MATRIX8, // ArgumentType.MATRIX8,
                            defaultValue: '0001100000111100011111101101101100011000000110000001100000011000'
                            // defaultValue: '0000000000000000000000000000000000000000000000000000000000000000'
                        }
                    }
                }, {
                    opcode: 'displayImage',
                    blockType: BlockType.COMMAND, // BlockType COMMAND
                    text: formatMessage({
                        id: 'aixiong.displayImage',
                        default: '点阵屏预设图形 [image]',
                        description: 'displayImage'
                    }),
                    arguments: {
                        image: {
                            type: ArgumentType.STRING,
                            menu: 'image',
                            defaultValue: '0100001011100111111111111111111111111111011111100011110000011000'
                        }
                    }
                },
                {
                    opcode: 'showSensorPhotosensitive',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'aixiong.showSensorPhotosensitive',
                        default: '光敏传感器',
                        description: 'showSensorPhotosensitive'
                    })
                },
                {
                    opcode: 'showSensorSound',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'aixiong.showSensorSound',
                        default: '声音传感器',
                        description: 'showSensorSound'
                    })
                },
                {
                    opcode: 'showSensorAvoidance',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'aixiong.showSensorAvoidance',
                        default: '避障传感器',
                        description: 'showSensorAvoidance'
                    })
                },
                {
                    opcode: 'switchColor',
                    blockType: BlockType.COMMAND,
                    text: '颜色识别块 [switchMenu]',
                    arguments: {
                        // 方括号中定义的
                        switchMenu: {
                            type: ArgumentType.STRING,
                            menu: 'switchMenu',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'showSensorColorRGB',
                    blockType: BlockType.REPORTER,
                    // checkable: true,
                    text: '颜色识别块 [rgbMenu] 值',
                    arguments: {
                        rgbMenu: {
                            type: ArgumentType.STRING,
                            menu: 'rgbMenu',
                            defaultValue: '1'
                        }
                    }
                },
                // {
                //     opcode: 'showSensorColor',
                //     blockType: BlockType.BOOLEAN,
                //     text: '颜色识别块 识别为 [colorMenu]',
                //     arguments: {
                //         colorMenu: {
                //             type: ArgumentType.STRING,
                //             menu: 'colorMenu',
                //             defaultValue: '1'
                //         }
                //     }
                // },
                {
                    opcode: 'switchGesture',
                    blockType: BlockType.COMMAND,
                    text: '手势识别块 [switchMenu]',
                    arguments: {
                        switchMenu: {
                            type: ArgumentType.STRING,
                            menu: 'switchMenu',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'showGesture',
                    blockType: BlockType.BOOLEAN,
                    text: '手势识别块 识别为 [gestureMenu]',
                    arguments: {
                        gestureMenu: {
                            type: ArgumentType.STRING,
                            menu: 'gestureMenu',
                            defaultValue: '1'
                        }
                    }
                },
                // {
                //     opcode: 'showGestureValue',
                //     blockType: BlockType.REPORTER,
                //     // checkable: true,
                //     text: '手势识别块值',
                //     arguments: {
                //     }
                // },
            ],

            menus: {
                ledDigit: [
                    {text: '灭', value: '0'},
                    {text: '亮', value: '200'},
                    {text: '变色', value: '1'}
                ],
                // aixiongPin: [
                //     "0",
                //     "1",
                //     "2",
                //     "3",
                //     "4",
                //     "5",
                //     "6",
                //     "7",
                //     "10",
                //     "11",
                //     "A0",
                //     "A1",
                //     "A2",
                //     "A3",
                //     "A4",
                //     "A5",
                // ],
                aixiongPin: [

                    {text: 'D2', value: '2'},
                    {text: 'D5', value: '5'},
                    {text: 'D10', value: '10'},
                    {text: 'A0', value: 'A0'},
                    {text: 'A1', value: 'A1'}
                ],
                modules: [
                    {text: '七彩变色灯', value: 'ledPin'},
                    {text: '电机', value: 'motorPin'},
                    {text: '点阵屏', value: 'matrixPin'},
                    {text: '光敏传感器', value: 'sensorPhotosensitivePin'},
                    {text: '声音传感器', value: 'sensorSoundPin'},
                    {text: '避障传感器', value: 'sensorAvoidancePin'}
                    // { text: "可调节延期块", value: "delayPin" },
                ],
                matrixRotation: [
                    {text: '0°', value: '0'},
                    {text: '逆时针90°', value: '1'},
                    {text: '逆时针180°', value: '2'},
                    {text: '逆时针270°', value: '3'}
                ],
                image: [
                    {text: '↑', value: '0001100000111100011111101101101100011000000110000001100000011000'},
                    {text: '↓', value: '0001100000011000000110000001100011011011011111100011110000011000'},
                    {text: '←', value: '0001000000110000011000001111111111111111011000000011000000010000'},
                    {text: '→', value: '0000100000001100000001101111111111111111000001100000110000001000'},
                    {text: '♥', value: '0100001011100111111111111111111111111111011111100011110000011000'},
                    {text: '▲', value: '0000000000000000000110000011110001111110111111110000000000000000'},
                    {text: '▼', value: '0000000000000000111111110111111000111100000110000000000000000000'},
                    {text: '◄', value: '0000010000001100000111000011110000111100000111000000110000000100'},
                    {text: '►', value: '0010000000110000001110000011110000111100001110000011000000100000'},
                    {text: '△', value: '0000000000000000000110000010010001000010111111110000000000000000'},
                    {text: '▽', value: '0000000000000000111111110100001000100100000110000000000000000000'},
                    {text: '☺', value: '0011110001000010101001011000000110100101100110010100001000111100'},
                    {text: '○', value: '0011110001000010100000011000000110000001100000010100001000111100'},
                    {text: '◑', value: '0011110001001110100011111000111110001111100011110100111000111100'},
                    {text: '◐', value: '0011110001110010111100011111000111110001111100010111001000111100'},
                    {text: '￥', value: '0100001000100100111111110001000011111111000100000001000000010000'},
                    {text: 'Χ', value: '1000000101000010001001000001100000011000001001000100001010000001'},
                    {text: '√', value: '0000000000000001000000100100010000101000000100000000000000000000'},
                    {text: '□', value: '0000000001111110010000100100001001000010010000100111111000000000'},
                    {text: '▣', value: '0000000001111110010000100101101001011010010000100111111000000000'},
                    {text: '◇', value: '0001100000100100010000101000000110000001010000100010010000011000'},
                    {text: '♀', value: '0001110000100010001000100010001000011100000010000011111000001000'},
                    {text: '♂', value: '0000111100000011000001010111100111011000100010001101100001110000'},
                    {text: '♪', value: '0000110000001110000010110000100000001000011110001111100001100000'},
                    {text: '✈', value: '0010000000110000100110001111111111111111100110000011000000100000'},
                    {text: '卍', value: '1111001000010010000100101111111010010000100100001001111000000000'},
                    {text: '卐', value: '1001111010010000100100001111111000010010000100101111001000000000'},
                    {text: '|', value: '0001000000010000000100000001000000010000000100000001000000010000'},
                    {text: '—', value: '0000000000000000000000000000000011111111000000000000000000000000'},
                    {text: '╱', value: '0000000100000010000001000000100000010000001000000100000010000000'},
                    {text: '＼', value: '1000000001000000001000000001000000001000000001000000001000000001'},
                    {text: '大', value: '0000100000001000011111110000100000001000000101000010001001000001'},
                    {text: '中', value: '0001000000010000111111101001001010010010111111100001000000010000'},
                    {text: '小', value: '0000100000001000000010000010101000101010010010010000100000001110'},
                    {text: '米', value: '1001001001010100001110001111111000111000010101001001001000000000'},
                    {text: '正', value: '1111111100001000000010000100111101001000010010000100100011111111'},
                    {text: '囧', value: '1111111110100101101001011100001110111101101001011010010111111111'}
                ],
                switchMenu: [
                    {text: '开', value: '1'},
                    {text: '关', value: '2'}
                ],
                rgbMenu: [
                    {text: '红色', value: '1'},
                    {text: '绿色', value: '2'},
                    {text: '蓝色', value: '3'}
                ],
                colorMenu: [
                    {text: '红色', value: '1'},
                    {text: '绿色', value: '2'},
                    {text: '蓝色', value: '3'},
                    {text: '橙色', value: '4'},
                    {text: '黄色', value: '5'},
                    {text: '青色', value: '6'},
                    {text: '紫色', value: '7'}
                ],
                gestureMenu: [
                    {text: '向上', value: '1'},
                    {text: '向下', value: '2'},
                    {text: '向左', value: '3'},
                    {text: '向右', value: '4'},
                    {text: '远离', value: '5'},
                    {text: '靠进', value: '6'}
                ],
            }
        };
    }

    /**
     * TODO 这个是摘取过来的，作用还没有彻底搞明白。
     * Retrieve the block primitives implemented by this package.
     * @return {object.<string, Function>} Mapping of opcode to Function.
     */
    // noop(){
    //     return Promise.reject(formatMessage({
    //         id: 'kblock.notify.nosupportonlinemode',
    //         defaultMessage: 'Not support in online mode'
    //     }));
    // }
    delayPromise () {
        return new Promise(resolve => {
            let thisInterval = setInterval(() => {
                if (this.running == false) {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve();
                }
            }, 16);
        });
    }
    valuePromise (valueStr) {
        return new Promise(resolve => {
            let count = 0
            let thisInterval = setInterval(() => {
                console.log(this[valueStr])
                count++
                if (count >= 20) {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve('')
                }
                if (this[valueStr] !== '') {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve(this[valueStr])
                }
            }, 100)
        });
    }
    booleanPromise (valueStr, value) {
        return new Promise(resolve => {
            let count = 0
            let thisInterval = setInterval(() => {
                console.log(this[valueStr])
                count++
                if (count >= 20) {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve(false)
                }
                if (this[valueStr] !== '') {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve((this[valueStr] == value))
                }
            }, 100)
        });
    }

    baseSetup (args, util) {
        // TODO 到2020-06-08为止点击这个块会报“vm Primitive rejected promise:  undefined” 错误，猜测可能和上面的func: 'noop'有关
        // opcode 函数主要用在交互模式
        console.log('blocks args: ', args);
        console.log('util.target: ', util.target);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
    }
    changeLedDigit (args, util) {
        // opcode 函数主要用在交互模式
        console.log('blocks args: ', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }


        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        // console.log('util.target: ', util.target);
        let ledDigit = args.ledDigit;
        // 设置七彩灯状态 ledDigit 0 灭 200 亮 255 变色
        // 或者 0 灭 1 亮 1 变色 亮与变色有冲突
        // let ledDigit = args.ledDigit
        // console.log('====args', args);
        let method = 'digitalWrite'
        switch (parseInt(ledDigit)) {
            case 0:
            case 1:
                method = 'digitalWrite'
                if (this.ledPinMode == 3) {
                    this.ledPinMode = 1
                    this.socket && this.socket.emit('trans_from_scratch3', {
                        method: 'pinMode',
                        params: {
                            param1: this.ledPin,
                            param2: 1
                        }
                    })
                }
                break;
            default:
                method = 'analogWrite'
                if (this.ledPinMode == 1) {
                    this.ledPinMode = 3
                    this.socket && this.socket.emit('trans_from_scratch3', {
                        method: 'pinMode',
                        params: {
                            param1: this.ledPin,
                            param2: 3
                        }
                    })
                }
                break;
        }
        this.socket && this.socket.emit('trans_from_scratch3', {
            method,
            params: {
                param1: parseInt(this.ledPin),
                param2: parseInt(ledDigit)
            }
        })
        return this.delayPromise()
        // this.ledPinMode = 0 analog, 1 digital
        // this.ledPinValue = ledDigit
        // this[`${args.modules}Mode`] = pinMode
    }
    changeLedAnalog (args, util) {
        // opcode 函数主要用在交互模式
        console.log('blocks args: ', args);
        console.log('util.target: ', util.target);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        let ledAnalog = args.ledAnalog;
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true

        if (this.ledPinMode == 1) {
            this.ledPinMode = 3
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'pinMode',
                params: {
                    param1: this.ledPin,
                    param2: 3
                }
            })
        }
        
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'analogWrite',
            params: {
                param1: parseInt(this.ledPin),
                param2: parseInt(ledAnalog)
            }
        })
        return this.delayPromise()
        // 设置七彩灯亮度 ledAnalog 0 - 255
        // let ledAnalog = args.ledAnalog
    }

    // just for fun
    // say(args, util) {
    //     const message = args.TEXT;
    //     console.log(message);
    //     this.runtime.emit("SAY", util.target, "say", message);
    // }

    setModuleToPin (args) {
        console.log('setModuleToPin', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true

        let pinMode = 1
        switch (args.aixiongPin) {
            case 'A0':
            case 'A1':
                pinMode = 2
                break;
            default:
                args.aixiongPin = parseInt(args.aixiongPin)
                pinMode = 1;
                break;
        }

        if (args.modules == 'matrixPin') {
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'matrix_set',
                params: {
                    param1: args.aixiongPin,
                    param2: args.aixiongPin + 1
                }
            })
        } else {
            let param1
            if (args.aixiongPin == 'A0' || args.aixiongPin == 'A1') {
                param1 = analogTrans[args.aixiongPin]
            } else {
                param1 = args.aixiongPin
            }
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'pinMode',
                params: {
                    param1,
                    param2: pinMode
                }
            })
        }
        
        this[args.modules] = args.aixiongPin
        
        this[`${args.modules}Mode`] = pinMode
        console.log('args.modules -> ', args.modules)
        // aixiongPin: [
        //     {text: 'D2', value: '2'},
        //     {text: 'D5', value: '5'},
        //     {text: 'D10', value: '10'},
        //     {text: 'A0', value: 'A0'},
        //     {text: 'A1', value: 'A1'}
        // ],
        // modules: [
        //     {text: '七彩变色灯', value: 'ledPin'},
        //     {text: '电机', value: 'motorPin'},
        //     {text: '点阵屏', value: 'matrixPin'},
        //     {text: '光敏传感器', value: 'sensorPhotosensitivePin'},
        //     {text: '声音传感器', value: 'sensorSoundPin'},
        //     {text: '避障传感器', value: 'sensorAvoidancePin'}
        // pinMode(pin, board.MODES.PWM)
        // MODES = {
        //     INPUT: 0x00,
        //     OUTPUT: 0x01,
        //     ANALOG: 0x02,
        //     PWM: 0x03,
        //     SERVO: 0x04,
        //     SHIFT: 0x05,
        //     I2C: 0x06,
        //     ONEWIRE: 0x07,
        //     STEPPER: 0x08,
        //     SERIAL: 0x0a,
        //     PULLUP: 0x0b,
        //     IGNORE: 0x7f,
        //     PING_READ: 0x75,
        //     UNKOWN: 0x10,
        // }
        return this.delayPromise()
    }
    showSensorPhotosensitive (args) {
        console.log('showSensorPhotosensitive', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'analogRead',
            params: {
                param1: analogTrans[this.sensorPhotosensitivePin],
                param2: 0
            }
        })
        this.sensorPhotosensitivePinValue = ''

        return this.valuePromise('sensorPhotosensitivePinValue')

        // const valuePromise = new Promise(resolve => {
        //     let count = 0
        //     let _interval = setInterval(() => {
        //         console.log(this.sensorPhotosensitivePinValue)
        //         count++
        //         if (count >= 20) {
        //             clearInterval(_interval)
        //             _interval = null
        //             resolve('')
        //         }
        //         if (this.sensorPhotosensitivePinValue !== '') {
        //             clearInterval(_interval)
        //             _interval = null
        //             resolve(this.sensorPhotosensitivePinValue)
        //         }
        //     }, 100)
        // });
        // valuePromise.then(value => value);
        // return valuePromise;
    }
    showSensorSound (args) {
        console.log('showSensorSound', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'analogRead',
            params: {
                param1: analogTrans[this.sensorSoundPin],
                param2: 0
            }
        })
        this.sensorSoundPinValue = ''

        return this.valuePromise('sensorSoundPinValue')
    }
    showSensorAvoidance (args) {
        console.log('showSensorAvoidance', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'analogRead',
            params: {
                param1: analogTrans[this.sensorAvoidancePin],
                param2: 0
            }
        })
        this.sensorAvoidancePinValue = ''

        return this.valuePromise('sensorAvoidancePinValue')
        // return valueDelay(this.sensorAvoidancePinValue);        
        
    }
    showDelay (args) {
        console.log('showDelay', args);
    }

    changeMotorAnalog (args) {
        // 设置电机转速 motorAnalog 0 - 255
        // 或者 0 关 1 开
        // let motorAnalog = args.motorAnalog;
        console.log('changeMotorAnalog', args);
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        let motorAnalog = args.motorAnalog;
        motorAnalog = parseInt(motorAnalog)
        if (motorAnalog == 0) {
            // digitalWrite(motorPin+1, 0);
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'digitalWrite',
                params: {
                    param1: parseInt(this.motorPin) + 1,
                    param2: 0
                }
            })
        } else if (motorAnalog > 0){
            // digitalWrite(motorPin+1, 0);
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'digitalWrite',
                params: {
                    param1: parseInt(this.motorPin) + 1,
                    param2: 0
                }
            })
        } else {
            // digitalWrite(motorPin+1, 1);
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'digitalWrite',
                params: {
                    param1: parseInt(this.motorPin) + 1,
                    param2: 1
                }
            })
        }
        // analogWrite(motorPin, motorAnalog);
        if (this.motorPinMode != 3) {
            this.motorPinMode = 3
            this.socket && this.socket.emit('trans_from_scratch3', {
                method: 'pinMode',
                params: {
                    param1: parseInt(this.motorPin),
                    param2: 3
                }
            })
        }
        
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'analogWrite',
            params: {
                param1: parseInt(this.motorPin),
                param2: motorAnalog//Math.abs(motorAnalog)
            }
        })
        return this.delayPromise()
    }

    changeMatrixText (args) {
        // 设置点阵屏文字 matrixText 支持 数字，字母
        let matrixText = args.matrixText
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'matrix_show',
            params: {
                param1: matrixText
            }
        })
        return this.delayPromise()
        // valueDelayPromise('', 5);

    }
    changeMatrixRotation (args) {
        // 设置旋转角度 matrixRotation 逆时针
        let matrixRotation = args.matrixRotation
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        
        this.running = true
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'matrix_rotate',
            params: {
                param1: parseInt(matrixRotation)
            }
        })
        return this.delayPromise()
    }
    changeMatrixTextDuration (args) {
        // 文字时间间隔
        // let max = -(matrixTextDuration * 10 - 7)
        // for (int8_t x = 7; x >= max; x--)
        // {
        //   matrix.clear();
        //   matrix.setCursor(x, 0);
        //   matrix.print('Long');
        //   matrix.writeDisplay();
        //   delay(100);
        // }
        let matrixTextDuration = args.matrixTextDuration
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        
        this.running = true
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'matrix_speed',
            params: {
                param1: matrixTextDuration
            }
        })
        return this.delayPromise()
    }
    displayMatrix (args) {
        console.log('matrix8', args)
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        
        this.running = true
        const symbol = (args.MATRIX8).replace(/\s/g, '');

        let ledMatrixState2 = [];

        ledMatrixState2[0] = to16(symbol.substring(56, 64))
        ledMatrixState2[1] = to16(symbol.substring(48, 56))
        ledMatrixState2[2] = to16(symbol.substring(40, 48))
        ledMatrixState2[3] = to16(symbol.substring(32, 40))
        ledMatrixState2[4] = to16(symbol.substring(24, 32))
        ledMatrixState2[5] = to16(symbol.substring(16, 24))
        ledMatrixState2[6] = to16(symbol.substring(8, 16))
        ledMatrixState2[7] = to16(symbol.substring(0, 8))
        // console.log('ledMatrixState2 --> ', ledMatrixState2)
        let result = '{' + ledMatrixState2.join(',') + '}'
        console.log('ledMatrixState2 --> ', result)
        
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'matrix_show',
            params: {
                param1: ledMatrixState2
            }
        })
        return this.delayPromise()
    }
    displayImage (args) {
        console.log('0000010204885020', args)
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return 
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        const symbol = (args.image).replace(/\s/g, '');

        let ledMatrixState2 = []
        ledMatrixState2[0] = to16(symbol.substring(56, 64))
        ledMatrixState2[1] = to16(symbol.substring(48, 56))
        ledMatrixState2[2] = to16(symbol.substring(40, 48))
        ledMatrixState2[3] = to16(symbol.substring(32, 40))
        ledMatrixState2[4] = to16(symbol.substring(24, 32))
        ledMatrixState2[5] = to16(symbol.substring(16, 24))
        ledMatrixState2[6] = to16(symbol.substring(8, 16))
        ledMatrixState2[7] = to16(symbol.substring(0, 8))
        let result = '{' + ledMatrixState2.join(',') + '}'
        console.log('ledMatrixState2 --> ', result)
        
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'matrix_show',
            params: {
                param1: ledMatrixState2
            }
        })
        return this.delayPromise()
    }

    switchColor (args) {
        let switchMenu = args.switchMenu
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'color_setup',
            params: {
                param1: switchMenu
            }
        })
        return this.delayPromise()
    }
    switchGesture (args) {
        let switchMenu = args.switchMenu
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        if (this.running) {
            console.log('running');
            return;
        }
        this.running = true
        this.socket && this.socket.emit('trans_from_scratch3', {
            method: 'gesture_setup',
            params: {
                param1: switchMenu
            }
        })
        return this.delayPromise()
    }
    showSensorColorRGB (args) {
        console.log('showSensorColorRGB', args);
        let rgbMenu = args.rgbMenu
        
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        this[numRGBMap[rgbMenu]] = ''
        // sensorColorRedValue
        // sensorColorGreenValue
        // sensorColorBlueValue
        // sensorColorValue
        return this.valuePromise(numRGBMap[rgbMenu])
    }
    showSensorColor (args) {
        // colorMenu: [
        //     {text: '红色', value: '1'},
        //     {text: '绿色', value: '2'},
        //     {text: '蓝色', value: '3'}
        // ],
        console.log('showSensorColor', args);
        let colorMenu = args.colorMenu
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        this.sensorColorValue = ''
        return this.booleanPromise('sensorColorValue', colorMenu)
    }
    showGesture (args) {
        // gestureMenu: [
        //     {text: '向上', value: '1'},
        //     {text: '向下', value: '2'},
        //     {text: '向左', value: '3'},
        //     {text: '向右', value: '4'},
        //     {text: '远离', value: '5'},
        //     {text: '靠进', value: '6'},
        // ],
        console.log('showGesture', args);
        let gestureMenu = args.gestureMenu
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        // this.sensorGestureValue = ''
        return this.booleanPromise('sensorGestureValue', gestureMenu)
    }
    showGestureValue (args) {
        console.log('showGestureValue', this.sensorGestureValue);
        
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        return this.valuePromise('sensorGestureValue')
    }
    
}

module.exports = aixiongBlocks;
